import { OnboardingServiceModule } from 'services/data/onboarding.service';
import { OptimizelyServiceModule } from 'services/data/optimizely.service';

export const VideoSliderServiceModule = angular
    .module('app.components.videoSlider.videoSliderService', [OnboardingServiceModule, OptimizelyServiceModule])
    .service('videoSliderService', (
        $rootScope,
        $window,
        onboardingService,
        optimizelyService
    ) => {
        var api = {
            openSlider,
            closeSlider
        };

        return api;

        function openSlider(videoName) {
            if (!$window.dataLayer) $window.dataLayer = [];

            onboardingService.completeTask(`video.${videoName}`);
            $window.dataLayer.push({
                event: `admin_onboarding_watchvideo_${videoName}`
            });

            optimizelyService.trackEvent('action_complete');

            $rootScope.$emit('videoSliderService:openSlider', videoName);
        }

        function closeSlider() {
            $rootScope.$emit('videoSliderService:closeSlider');
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/videoSlider/videoSlider.service.js